import { Component, ElementRef, Inject, OnInit, Optional, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PreviewBonusMailTemplateProps } from './preview-mail-template.types';

declare var nicEditor: any;
declare var $: any;

@Component({
  selector: 'preview-mail-template',
  templateUrl: './preview-mail-template.component.html',
  styleUrls: ['./preview-mail-template.component.scss'],
  host: {
    class: `d-block`
  }
})
export class PreviewMailTemplateComponent implements OnInit {
  @ViewChild('previewZone') previewZone: ElementRef<HTMLDivElement>;
  editor: any;
  subject = '';
  passingContentTimeout: number;
  isEditMode = false;

  constructor(
    @Optional() @Inject(MAT_DIALOG_DATA) public readonly dialogData: PreviewBonusMailTemplateProps,
    private readonly dialogRef: MatDialogRef<unknown>,
  ) { }

  ngOnInit(): void {
    this.subject = this.dialogData.subject;
  }



  apply() {
    this.dialogRef.close({
      template: {
        subject: this.subject,
        content: ($('#fill-content').text()).replaceAll('\n', '')
      } as PreviewBonusMailTemplateProps
    });
  }

  resetTemplate() {
    this.subject = this.dialogData.defaultData.subject;
    this.editor.nicInstances[0].elm.innerHTML = this.dialogData.defaultData.content;
  }

  initWys(): void {
    this.passingContentTimeout = setTimeout(() => {
      try {
        this.editor = new nicEditor({ fullPanel: false }).panelInstance(
          'areaAll'
        );
        // unselectable="on"
        $('.nicEdit-panelContain').css('display', 'none');
        this.editor.nicInstances[0].elm.innerHTML = this.dialogData.content;
        this.editor.nicInstances[0].elm.setAttribute('contenteditable', 'false');
        this.editor.addEvent('blur', function () {
          if (this.instanceById('areaAll')) {
            const text = this.instanceById('areaAll').getContent();
            $('#fill-content').text(text);
          }
        });
        (this.previewZone.nativeElement.children[1] as HTMLDivElement).style.border = "none";
      } catch (e) {}
    }, 500);
  }

  ngAfterViewInit() {
    this.initWys();
  }

  ngOnDestroy() {
    clearTimeout(this.passingContentTimeout);
  }
}
